/**
 * Registro global de pontos de snap entre canos (pipes).
 *
 * Substitui o React Context `pipe-snap-context` do Syncou por um singleton
 * simples. Cada ViewShowPipe registra seus vertices resolvidos (em coordenadas
 * de pagina) sob um id unico; ao desenhar/arrastar, o drawer ou outro pipe
 * consulta `getOtherPoints(id)` para alinhar com os vertices dos demais canos.
 *
 * Coordenadas sempre em espaco de pagina (clientX + window.scrollX) para que
 * sejam comparaveis entre componentes posicionados independentemente.
 */

const registry = new Map()

export const pipeSnapRegistry = {
  register(id, points) {
    registry.set(id, points)
  },
  unregister(id) {
    registry.delete(id)
  },
  /**
   * Retorna todos os pontos registrados, exceto os do id informado.
   * @param {string} excludeId
   * @returns {Array<{x: number, y: number}>}
   */
  getOtherPoints(excludeId) {
    const result = []
    for (const [id, points] of registry.entries()) {
      if (id === excludeId) continue
      for (const p of points) {
        result.push(p)
      }
    }
    return result
  },
}

export default pipeSnapRegistry
